<mat-card class="pme-product-choice card">
    <mat-card-content>
        <span>
            <div class="resume-title" *ngIf="showPlanResume">Resumo do pedido</div>
            <mat-divider *ngIf="showPlanResume" inset ></mat-divider>
            <div class="pme-product-choice-header display-utils-row display-utils-between display-utils-gap-8">
                <div class="title">
                    <!-- Plano Selecionado -->
                    {{this.cardTitle}}
                </div>
                
                <div *ngIf="!this.validationToken">
                    <div class="pme-text-right"
                        *ngIf="this.changeText && this.changeLink && !this.singlePlanProduct && this.classificationIdentifier && this.classificationIdentifier !== 'plano-mensal';else other_content">
                        <!-- <a href="">Mudar plano</a> -->
                        <a [routerLink]="this.newChangeLink">{{this.changeText}}</a>
                    </div>
                    <ng-template #other_content>
                        <!-- <a href="">Mudar plano</a> -->
                        <a href="{{this.newChangeLink}}">{{this.changeText}}</a>
                    </ng-template>
                </div>
            </div>

            <div *ngIf="this.orderCode" class="pme-product-choice-item display-utils-row display-utils-between-center display-utils-gap-16">
                <div>
                    <!-- <b>Saúde do Seu Negócio - Padrão Semestral</b> -->
                    <p>Pedido</p>
                </div>
                <div class="pme-text-right">
                    <!-- R$ 238,00 -->
                    {{this.orderCode}}
                </div>
            </div>
            <div class="display-utils-row display-utils-between-center display-utils-gap-16">
            <div class="pme-product-choice-item display-utils-row display-utils-between-center display-utils-gap-16">
                <div>
                    <!-- <b>Saúde do Seu Negócio - Padrão Semestral</b> -->
                    <p>{{this.productName}}</p>
                    
                </div>
            </div>
            <div class="pme-product-choice-item display-utils-row display-utils-between-center display-utils-gap-16">
                <div class="pme-text-right product-price">
                    <!-- R$ 238,00 -->
                    <p *ngIf="!this.productNameBold"> {{this.totalValue | currency: 'R$'}}</p>
                    <b *ngIf="this.productNameBold"> {{this.totalValue | currency: 'R$'}}</b>
                </div>
            </div>
        </div>
            <div class="pme-product-choice-list display-utils-row display-utils-between-center display-utils-gap-8"
                *ngIf="this.extraBalanceCoupon && this.extraBalanceCoupon.type === 'EXTRA_BALANCE'">
                <div>
                    Bônus desta compra
                </div>
                <div class="pme-text-right pme-price-success">
                    + {{this.extraBalanceCoupon.extraBalance | currency: 'R$'}}
                </div>
            </div>

            <div class="pme-product-choice-item  pme-product-choice-total display-utils-row display-utils-between-center display-utils-gap-16"
                *ngIf="this.extraBalanceCoupon && this.extraBalanceCoupon.type === 'EXTRA_BALANCE'">
                <div>
                    <b>Total de créditos recebidos</b>
                </div>
                <div class="pme-text-right">
                    <b>{{this.extraBalanceCoupon.totalCredit| currency: 'R$'}}</b>
                </div>
            </div>

            <p class="pme-product-choice-description mat-body" *ngIf="this.description">
                <!-- O plano selecionado contempla o período de 12 meses a partir da confirmação do pagamento. -->
                {{this.description}}
            </p>
        </span>
    <div class="changePlan-button" (click)="returnToPlans()"
        *ngIf="this.classificationIdentifier && this.shopWindowLink &&  this.classificationIdentifier === 'consulta-e-recuperacao-de-dividas'">
        <div class="button-container">
            <span class="link">Alterar plano</span>
        </div>
    </div>

        <ng-container *ngIf="this.newProduct">
            <br>
            <mat-divider inset></mat-divider>
            <div class="pme-product-choice-header display-utils-row display-utils-between display-utils-gap-8">
                <div class=" title new-plan">
                    Novo Plano
                </div>
            </div>

            <div class="pme-product-choice-item display-utils-row display-utils-between-center display-utils-gap-16">
                

                    
                    <div>

                        <b class="new-plan-info">{{this.newProduct.name}}</b>
                        </div>
                        <div class="pme-text-right">
                        
                            <b class="new-plan-info">{{this.newProduct.value | currency: 'R$'}}</b>
                        </div>
                        
                        </div>
                        <div class="changePlan-button" (click)="returnToPlans()"
                            *ngIf="classificationIdentifier && (classificationIdentifier === 'monitore-clientes' || classificationIdentifier ==='plano-mensal') && shopWindowLink">
                            <div class="button-container">
                                <span class="link">Alterar plano</span>
                            </div>
                        </div>

            <div class="divider">
                <div class="subscriptionDate display-utils-row display-utils-between-center display-utils-gap-16" style="margin-bottom: 10px;">
                    <div>

                        <p>Início da assinatura</p>
                    </div>
                    <div class="pme-text-right">

                        <p>{{this.startSubscription}}</p>
                    </div>
                </div>

                <div class="subscriptionDate display-utils-row display-utils-between-center display-utils-gap-16">
                    <div>

                        <p>Término da assinatura</p>
                    </div>
                    <div class="pme-text-right" >

                        <b>{{this.endSubscription}}</b>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-content></ng-content>

        <!-- <ul class="pme-product-choice-list mat-body">
      <li class="display-utils-row display-utils-between-center display-utils-gap-8">
        <div>Início da assinatura</div>
        <div class="pme-text-right">26/05/2020</div>
      </li>
      <li class="display-utils-row display-utils-between-center display-utils-gap-8">
        <div>Término da assinatura</div>
        <div class="pme-text-right">25/05/2021</div>
      </li>
      <li class="display-utils-row display-utils-between-center display-utils-gap-8">
        <div>Última cobrança</div>
        <div class="pme-text-right">17/06/2020</div>
      </li>
      <li class="display-utils-row display-utils-between-center display-utils-gap-8">
        <div>Forma de pagamento</div>
        <div class="pme-text-right">Boleto bancário</div>
      </li>
      <li class="display-utils-row display-utils-between-center display-utils-gap-8">
        <div>Catão cadastrado</div>
        <div class="pme-text-right">•••• 1241</div>
      </li>
    </ul> -->

    </mat-card-content>
</mat-card>
